export const MODULE = 'module';
export const ROW = 'row';
export const COLUMN = 'column';
export const SECTION = 'section';